import client from "../client";

export interface GetIPhoneRewardRequest {
  prefix: string;
}

export interface GetIPhoneRewardResponse {
  Username: string;
  Created_at: string;
  Updated_at: string;
  DisplayCreatedAt: string;
  DisplayUpdatedAt: string;
  Note?: string;
}

export default function API(
  request: GetIPhoneRewardRequest
): Promise<GetIPhoneRewardResponse[]> {
  return client
    .get(`gameinhouse/uspin/get_iphone_reward`, { params: request })
    .then((response) => response.data);
}
